import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";
import TotalRow from './components/TotalRow';
import { PAGE_LIMIT } from "../../config";

const PushapiExtendedTable = ({ report, total, activePage, onSortChange }) => {
    const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
    const pageEnd = activePage * PAGE_LIMIT;

    report = report.slice(pageStart, pageEnd);
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('a')}>Affid</th>
                    <th onClick={() => onSortChange('s')}>Subid</th>
                    <th onClick={() => onSortChange('cc')}>Country</th>
                    <th onClick={() => onSortChange('rq')}>Requests</th>
                    <th onClick={() => onSortChange('rs')}>Responses</th>
                    <th onClick={() => onSortChange('i')}>Impressions</th>
                    <th onClick={() => onSortChange('w')}>Won %</th>
                    <th onClick={() => onSortChange('cl')}>Clicks</th>
                    <th onClick={() => onSortChange('ctr')}>CTR</th>
                    <th onClick={() => onSortChange('vC')}>VoluumClicks</th>
                    <th onClick={() => onSortChange('cv')}>Conversions</th>
                    <th onClick={() => onSortChange('cD')}>Click Disc %</th>
                    <th onClick={() => onSortChange('cs')}>Cost</th>
                    <th onClick={() => onSortChange('oR')}>Onw Revenue</th>
                    <th onClick={() => onSortChange('r')}>Revenue</th>
                    <th onClick={() => onSortChange('rT')}>Total Revenue</th>
                    <th onClick={() => onSortChange('roi')}>ROI %</th>
                    <th onClick={() => onSortChange('roi2')}>ROI</th>
                </tr>
            </thead>
            <tbody>
                <TotalRow data={total} />
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiExtendedTable;


// WEBPACK FOOTER //
// ./src/scenes/PushapiExtended/components/Table/index.js